<template>
  <div>
    <el-row class="title-bar" type="flex" justify="space-between">
      <div class="vertical-center-box">
        <div class="title-h4">알람 순차전송 템플릿 목록</div>
        <div class="setting-addel mr-l15">
          <el-button size="mini" @click="onAddTemplate"><i class="fas fa-plus"></i></el-button>
          <el-button size="mini" @click="onDeleteTemplate" :disabled="selectedRowArray.length === 0"><i class="fas fa-minus"></i></el-button>
        </div>
      </div>
      <div>
        <w-header-search-button size="mini" @click="setSearchToolVisible"></w-header-search-button>
      </div>
    </el-row>
    <el-table-wrapper :column-default="columnDefault" @condition-change="onChangeTable" :total="total" remote ref="alarmTable"
      @row-dblclick="onDblClickName" @selection-change="changeHandleSelection" :row-class-name="rowClass" :data="templateData" :columns="tableColumn" pagination :show-search-tool="showSearchTool"
      style="width:100%;" :show-custom-header="true">
      <template slot-scope="scope" slot="alarm2-setting-status">
        <span v-if="scope.row.alarmRepeat2ndApplyFlag == 'Y'" class="state-normal" style="font-size:23px;">●</span>
        <span v-else class="state-none" style="font-size:23px;">●</span>
      </template>
      <template slot-scope="scope" slot="alarm3-setting-status">
        <span v-if="scope.row.alarmRepeat3rdApplyFlag == 'Y'" class="state-normal" style="font-size:23px;">●</span>
        <span v-else class="state-none" style="font-size:23px;">●</span>
      </template>
    </el-table-wrapper>
    <w-alarm-template-add-sliding-popup ref="alarmTemplateAddpop" @load-data="loadData"></w-alarm-template-add-sliding-popup>
  </div>
</template>

<script>
import msgUtil from '@/utils/message';
import { columnDefault } from '@/constants/table';
import OperationSettingsAPI from '@/api/settings/common/operation-settings';
import { isNil, forEach } from 'lodash';
import { EMPTY_TEXT } from '@/utils/string';
import WAlarmTemplateAddSlidingPopup from './popup/AlarmTemplateAddSlidingPopup';

export default {
  name: 'WAlarmTemplate',
  components: {
    WAlarmTemplateAddSlidingPopup,
  },
  data() {
    return {
      total: null,
      columnDefault,
      showSearchTool: false,
      tableColumn: [
        {
          align: 'center',
          type: 'selection',
        },
        {
          prop: 'alarmRepeatId',
          label: '템플릿 ID',
          searchable: true,
          sortable: true,
          remoteProp: 'r.alarm_repeat_id',
        },
        {
          prop: 'alarmRepeatName',
          label: '템플릿명',
          searchable: true,
          sortable: true,
          remoteProp: 'r.alarm_repeat_name',
        },
        {
          prop: 'alarmRepeatInterval',
          label: '알람주기 (분)',
          formatter: this.getAlarmPeriodText,
        },
        {
          prop: 'alarmRepeat2ndApplyFlag',
          label: '2차 알람 설정',
          headerAlign: 'center',
          align: 'center',
          scopedSlot: 'alarm2-setting-status',
        },
        {
          prop: 'alarmRepeat2ndManagerName',
          label: '2차 알람 수신자',
          formatter: this.getEmptyText,
        },
        {
          prop: 'alarmRepeat2ndMinute',
          label: '2차 알람 조건',
          formatter: this.getAlarmPeriodText,
        },
        {
          prop: 'alarmRepeat3rdApplyFlag',
          label: '3차 알람 설정',
          headerAlign: 'center',
          align: 'center',
          scopedSlot: 'alarm3-setting-status',
        },
        {
          prop: 'alarmRepeat3rdManagerName',
          label: '3차 알람 수신자',
          formatter: this.getEmptyText,
        },
        {
          prop: 'alarmRepeat3rdMinute',
          label: '3차 알람 조건',
          formatter: this.getAlarmPeriodText,
        },
      ],
      templateData: [],
      minusButtonFlag: false,
      selectedRowArray: [],
    };
  },
  mounted() {
    this.loadData();
  },
  methods: {
    loadData() {
      this.selectedRowArray = []; // selected 초기화
      const tableParams = this.$refs.alarmTable.getParameter();
      const params = {
        ...tableParams,
      };
      OperationSettingsAPI.getAlarmTemplateList(params).then((response) => {
        if (response.data.success) {
          this.templateData = response.data.data;
          this.total = response.data.total;
        }
      });
    },
    onChangeTable() {
      this.loadData();
    },
    setSearchToolVisible() {
      this.showSearchTool = !this.showSearchTool;
    },
    // 템플릿 삭제
    onDeleteTemplate() {
      this.$confirm(...msgUtil.getBasicConfirmData(msgUtil.action.DELETE))
        .then(() => {
          const params = [];
          forEach(this.selectedRowArray, (item) => {
            params.push(item.alarmRepeatId);
          });
          OperationSettingsAPI.deleteAlarmTemplate(params).then((response) => {
            if (response.data.success) {
              this.loadData();
              this.$message(msgUtil.getResultMsgData(msgUtil.action.DELETE, '템플릿', true));
            }
          });
        })
        .catch(() => {});
    },
    onAddTemplate() {
      this.$refs.alarmTemplateAddpop.open();
    },
    // 테이블 체크박스 셀렉션 change함수
    changeHandleSelection(selectVal) {
      this.selectedRowArray = selectVal;
    },
    getEmptyText(row, column, value) {
      if (!isNil(value)) {
        return value;
      }
      return EMPTY_TEXT;
    },
    getAlarmPeriodText(row, column, value) {
      if (!isNil(value)) {
        return `${value}분 이후`;
      }
      return EMPTY_TEXT;
    },
    // table-row double click 이벤트
    onDblClickName(item) {
      this.$refs.alarmTemplateAddpop.open(item);
    },
    // 추후 row-class를 적용하는 클래스 필요
    rowClass() {
      // return 'table-point';
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/views/settings/operation/EventAlarmSettings/AlarmSettings/AlarmTemplate.vue